"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _styles = require("@material-ui/core/styles");
var _OptionListHeader = _interopRequireDefault(require("./OptionListHeader"));
var _OptionList = _interopRequireDefault(require("./OptionList"));
var _NoResultsOption = _interopRequireDefault(require("./NoResultsOption"));
var _LoadingMessage = _interopRequireDefault(require("./LoadingMessage"));
var _ActionFooter = _interopRequireDefault(require("./ActionFooter"));
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paper: {
      backgroundColor: theme.palette.opacity.black[80],
      borderRadius: '0 0 2px 2px',
      borderTop: '1px solid rgba(0, 0, 0, 0.12)',
      boxShadow: theme.shadows[4],
      minHeight: 32,
      minWidth: 221,
      paddingBottom: 0,
      paddingTop: 0
    }
  };
});
var MenuContainer = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var componentProps = props.componentProps,
    commonProps = props.commonProps;
  var actionFooterProps = commonProps.actionFooterProps,
    automationid = commonProps.automationid,
    dataMetrics = commonProps.dataMetrics,
    charsBeforeFetch = commonProps.charsBeforeFetch,
    menuIsOpen = commonProps.menuIsOpen,
    options = commonProps.options,
    isLoading = commonProps.isLoading,
    isAsync = commonProps.isAsync,
    searchInputValue = commonProps.searchInputValue,
    viewSelectedEnabled = commonProps.viewSelectedEnabled,
    value = commonProps.value;
  var isActionFooter = actionFooterProps.length > 0;
  var noResultsOptionProps = componentProps.noResultsOptionProps,
    loadingMessageProps = componentProps.loadingMessageProps,
    optionsListProps = componentProps.optionsListProps,
    optionsListHeaderProps = componentProps.optionsListHeaderProps,
    handleChangeFocus = componentProps.handleChangeFocus;
  var classes = useStyles();
  var tooFewCharacters = searchInputValue.length < charsBeforeFetch;
  var hasResults = options.length > 0;
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: ref
    }, /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
      square: true,
      className: "".concat(classes.paper)
    }, /*#__PURE__*/_react["default"].createElement(_LoadingMessage["default"], {
      componentProps: loadingMessageProps,
      commonProps: commonProps
    })));
  }
  var showNoResultsOption = !hasResults && !tooFewCharacters;
  var showOptionListHeader = hasResults || Boolean(hasResults || value.length) && isAsync;
  var showOptionList = hasResults && (isAsync ? Boolean(searchInputValue.length > 0 || viewSelectedEnabled) : true);
  var hasSomethingToShow = showNoResultsOption || showOptionListHeader || showOptionList;
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    automationid: "".concat(automationid, "-menu-container"),
    "data-metrics": dataMetrics.menuContainer
  }, menuIsOpen && hasSomethingToShow && /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    square: true,
    className: "".concat(classes.paper)
  }, showNoResultsOption && /*#__PURE__*/_react["default"].createElement(_NoResultsOption["default"], {
    componentProps: noResultsOptionProps,
    commonProps: commonProps
  }), showOptionListHeader && /*#__PURE__*/_react["default"].createElement(_OptionListHeader["default"], {
    componentProps: optionsListHeaderProps,
    commonProps: commonProps,
    isActionFooter: isActionFooter,
    handleChangeFocus: handleChangeFocus
  }), showOptionList && /*#__PURE__*/_react["default"].createElement(_OptionList["default"], {
    componentProps: optionsListProps,
    commonProps: commonProps
  }), isActionFooter && /*#__PURE__*/_react["default"].createElement(_ActionFooter["default"], {
    actionFooterProps: actionFooterProps,
    handleChangeFocus: handleChangeFocus
  })));
});
MenuContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  commonProps: _propTypes["default"].object,
  componentProps: _propTypes["default"].object
} : {};
var _default = MenuContainer;
exports["default"] = _default;